(() => {
  if (window.__ttTreadBuyBlockLoaded) return;
  window.__ttTreadBuyBlockLoaded = true;

  const BLOCK_SELECTOR = '[data-tt-tread-buy-block]';

  function money(cents) {
    const value = Number.parseInt(cents, 10) || 0;
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(value);
    return `$${(value / 100).toFixed(2)}`;
  }

  function getBlock(target) {
    return target?.closest?.(BLOCK_SELECTOR) || null;
  }

  function getSelectedOption(block) {
    const select = block?.querySelector('.tread-select');
    return select?.selectedOptions?.[0] || null;
  }

  function buildQuoteUrl(block, option) {
    const quoteBase = block.dataset.quoteBaseUrl || '/pages/request-a-quote';
    const variantInput = block.querySelector('[data-tread-variant-input]');
    const params = new URLSearchParams();
    params.set('product', block.dataset.productHandle || '');
    params.set('variant', option?.value || variantInput?.value || '');
    params.set('sku', option?.dataset.variantSku || '');
    params.set('title', block.dataset.productTitle || '');
    params.set('product_url', block.dataset.productUrl || '');
    params.set('source', 'tread_buy_block');
    return `${quoteBase}?${params.toString()}`;
  }

  function updateProductImage(block, option) {
    const imageUrl = option?.dataset.variantImage;
    if (!imageUrl) return;

    const section = block.closest('[id^="Main-Product-"]') || block.closest('.section-main-product') || block;
    const mainImage = section.querySelector('.product-media-item img');
    if (!mainImage) return;

    mainImage.src = imageUrl;
    mainImage.srcset = `${imageUrl} 1600w`;
  }

  function updateSelectedOption(block, option) {
    if (!block || !option) return;

    const price = Number.parseInt(option.dataset.variantPrice, 10) || 0;
    const compare = Number.parseInt(option.dataset.variantCompare, 10) || 0;
    const sellable = option.dataset.variantSellable === 'true';
    const isQuote = !sellable;

    const variantInput = block.querySelector('[data-tread-variant-input]');
    const priceEl = block.querySelector('[data-tread-price]');
    const compareEl = block.querySelector('[data-tread-compare]');
    const badgeEl = block.querySelector('[data-tread-badge]');
    const atcBtn = block.querySelector('[data-tread-add-button]');
    const addToQuoteBtn = block.querySelector('[data-tread-add-to-quote]');
    const quoteBtn = block.querySelector('[data-tread-quote-button]');
    const qtyWrap = block.querySelector('[data-tread-qty]');

    if (variantInput && variantInput.value !== option.value) {
      variantInput.value = option.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (priceEl) priceEl.textContent = money(price);

    const hasCompare = compare > price;
    if (compareEl) {
      compareEl.textContent = hasCompare ? money(compare) : '';
      compareEl.hidden = !hasCompare;
    }
    if (badgeEl) {
      badgeEl.textContent = hasCompare ? `SAVE ${money(compare - price)}` : '';
      badgeEl.hidden = !hasCompare;
    }

    if (qtyWrap) qtyWrap.hidden = isQuote;

    if (atcBtn) {
      atcBtn.hidden = isQuote;
      atcBtn.disabled = isQuote;
      atcBtn.setAttribute('aria-disabled', isQuote ? 'true' : 'false');
      const priceNode = atcBtn.querySelector('.tread-buy-block__atc-price');
      if (priceNode) priceNode.textContent = money(price);
    }

    const quoteHref = buildQuoteUrl(block, option);
    if (addToQuoteBtn) {
      addToQuoteBtn.hidden = isQuote;
      addToQuoteBtn.href = quoteHref;
    }
    if (quoteBtn) {
      quoteBtn.hidden = !isQuote;
      if (isQuote) quoteBtn.href = quoteHref;
    }

    updateProductImage(block, option);
  }

  function hydrateBlock(block) {
    if (!block) return;
    const option = getSelectedOption(block);
    if (option) updateSelectedOption(block, option);
    block.dataset.ttTreadInitialized = 'true';
  }

  function hydrate(context = document) {
    if (context.matches?.(BLOCK_SELECTOR)) hydrateBlock(context);
    context.querySelectorAll?.(BLOCK_SELECTOR).forEach(hydrateBlock);
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches?.(`${BLOCK_SELECTOR} .tread-select`)) return;
    const block = getBlock(event.target);
    updateSelectedOption(block, event.target.selectedOptions?.[0]);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(`${BLOCK_SELECTOR} .qty-btn`);
    if (!button) return;

    const block = getBlock(button);
    const input = block?.querySelector('.qty-field');
    if (!input) return;

    event.preventDefault();
    const current = Number.parseInt(input.value, 10) || 1;
    const min = Number.parseInt(input.min, 10) || 1;
    const max = Number.parseInt(input.max, 10) || 99;
    input.value = String(button.classList.contains('qty-minus') ? Math.max(min, current - 1) : Math.min(max, current + 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.(`${BLOCK_SELECTOR} form[data-type="add-to-cart-form"]`);
      if (!form) return;

      const block = getBlock(form);
      const quoteBtn = block?.querySelector('[data-tread-quote-button]');
      if (quoteBtn && !quoteBtn.hidden) {
        event.preventDefault();
        quoteBtn.click();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate(document), { once: true });
  } else {
    hydrate(document);
  }

  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
})();
